export default import.meta.ROLLDOWN_FILE_URL_7PUm3F_uVf$21BIFLSklvQ